//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import filters from '../../filters/index';
import * as utils from '../../utils/index';
import * as CONSTANTS from '../../constants/index';
import KeyBoard from '../../components/KeyBoard';
import memberModule from '@/common/memberModule';
import Group from 'vux/src/components/group/index.vue';
import XInput from 'vux/src/components/x-input/index.vue';
import { Popup,Dialog } from 'vant';
export default {
  name: 'license',
  data(){
    return{
      show:false,// 短信弹框
      licenseNo_page:this.$route.query.licenseNo,
      licenseNo: this.$route.query.licenseNo || '京A',//修改车牌号全部用setLicenseKB ,避免重复监听
      carBeans:utils.deepClone(CONSTANTS.CAR_BEANS),
      policyNo:this.$route.query.policyNo||'',
      frameNo:this.$route.query.frameNo||'',
      insuredName:this.$route.query.insuredName||'',
      proposalNo:this.$route.query.proposalNo||'',
      phone:this.$route.query.phone||'',
      identifyNumber:this.$route.query.identifyNumber || '',
      mergePolicyNo:this.$route.query.mergePolicyNo || '',//交商同保时，另一单的保单号
      startDate:this.$route.query.startDate || '',//起始期
      mergeStartDate:this.$route.query.mergeStartDate || '',//交商同保时，另一单的起始期
      productCode:this.$route.query.productCode || '',
      mergeProductCode:this.$route.query.mergeProductCode || '',
      endorByLicenseNoResult:'',
      second:120,
      fresh_text:'获取验证码', // 获取验证码   秒重新发送   重新获取
      verificationCode:'',//验证码内容
      disabled:false,// 是否允许点击验证码按钮
      stimeOut:'',//定时器
    }
  },
  created(){
    this.carBeans.vehicle.licenseNo = this.$route.query.licenseNo;
    if(this.$route.query.licenseNo=== '*-*'){
      this.carBeans.vehicle.licenseNo = '';
    }
    this.setLicenseKB(this.carBeans.vehicle.licenseNo);
    this.$set(this,'licenseNo',this.carBeans.vehicle.licenseNo)
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener('scroll',this.scrollToActiveTap,true)
    })
  },
  components: {
    KeyBoard,
    Group,
    XInput,
    [Popup.name]:Popup,
    [Dialog.Component.name]: Dialog.Component,
  },
  computed:{
    ...mapGetters(['getLicenseKB']),
    ...mapState({
    }),
    maskName(){
      return utils.mask(this.insuredName,'name')
    }
  },
  watch:{
    getLicenseKB(val) {
        //修改车牌号全部用setLicenseKB ,避免重复监听
        this.carBeans.vehicle.licenseNo = val;
        this.$set(this,'licenseNo',val)
    },
  },
  methods:{
    ...mapMutations({
      openKB:'openKB',
      hideKB:'hideKB',
      setLicenseKB:'setLicenseKB',
    }),
    plateFocus() {
      this.openKB();
    },
    clickBody(e) {
      this.hideKB();
    },
    endorByLicenseNo() {
      // let result = {
      //     "resultCode": "0",
      //     "errorMsg": null,
      //     "errorType": null,
      //     "interfaceId": null,
      //     "traceId": "1c5584aeb158ac47",
      //     "statusCode": "C0000000",
      //     "result": {
      //         "correctingNo": null,
      //         "companyCode": "0105110701",
      //         "operatorCode": "maozhirong@sinosafe.com.cn",
      //         "riskDtoList": [
      //             {
      //                 "applyEndorNo": "2051107031220230000007",
      //                 "riskCode": "0312",
      //                 "underwriteInd": "9",
      //                 "reviewType": null,
      //                 "endorNo": null,
      //                 "ilogInfos": [
      //                     {
      //                         "ruleMessage": "需核实车牌",
      //                         "ruleId": "X00P001",
      //                         "argumen": "转人工核保",
      //                         "sourceInd": "1",
      //                         "ruleType": null,
      //                         "preRuleType": null
      //                     },
      //                     {
      //                         "ruleMessage": "新车上牌转人工",
      //                         "ruleId": "X00P002",
      //                         "argumen": "转人工核保",
      //                         "sourceInd": "1",
      //                         "ruleType": null,
      //                         "preRuleType": null
      //                     }
      //                 ]
      //             },
      //             {
      //                 "applyEndorNo": "2051107030120230000006",
      //                 "riskCode": "0301",
      //                 "underwriteInd": "9",
      //                 "reviewType": null,
      //                 "endorNo": null,
      //                 "ilogInfos": [
      //                     {
      //                         "ruleMessage": "需核实车牌",
      //                         "ruleId": "X00P001",
      //                         "argumen": "转人工核保",
      //                         "sourceInd": "1",
      //                         "ruleType": null,
      //                         "preRuleType": null
      //                     },
      //                     {
      //                         "ruleMessage": "新车上牌转人工",
      //                         "ruleId": "X00P002",
      //                         "argumen": "转人工核保",
      //                         "sourceInd": "1",
      //                         "ruleType": null,
      //                         "preRuleType": null
      //                     }
      //                 ]
      //             }
      //         ]
      //     }
      // }
      // this.dealDone(result);
      // return;
      // this.$set(this,'endorByLicenseNoResult',result.result)
      // this.$set(this,'show',true);
      // return;
      var data = {
        "onlineCorrectingBaseVo": {
            "policyNo": this.policyNo,
            "phone": this.phone,
            "name": this.insuredName,
            "relFlag": (this.policyNo && this.mergePolicyNo) ? '1' : '0',
            "identifyNumber": this.identifyNumber
        },
        "onlineCorrectingVhlVo": {
            "licenseNo": this.licenseNo
        }
      }
      if(!this.licenseNo) {
        Toast('请录入车牌');
        return
      };
      // this.refreshing = true;
      $http.endorByLicenseNo({data}).then((res)=>{
        // 跳转详情
        if (res.resultCode == '000000' || res.resultCode == '0') { // 提核成功
          this.dealDone(res);
        } else if(res.resultCode == 'E28004'){ // 需要短信验证
          this.$set(this,'endorByLicenseNoResult',res.result)
          this.$set(this,'show',true);
        } else { // 替他错误信息返回触发
          Toast(res.errorMsg);
          // let result = {
          //     "resultCode": "0",
          //     "errorMsg": null,
          //     "errorType": null,
          //     "interfaceId": null,
          //     "traceId": "1c5584aeb158ac47",
          //     "statusCode": "C0000000",
          //     "result": {
          //         "correctingNo": null,
          //         "companyCode": "0105110701",
          //         "operatorCode": "maozhirong@sinosafe.com.cn",
          //         "riskDtoList": [
          //             {
          //                 "applyEndorNo": "2051107031220230000007",
          //                 "riskCode": "0312",
          //                 "underwriteInd": "9",
          //                 "reviewType": null,
          //                 "endorNo": null,
          //                 "ilogInfos": [
          //                     {
          //                         "ruleMessage": "需核实车牌",
          //                         "ruleId": "X00P001",
          //                         "argumen": "转人工核保",
          //                         "sourceInd": "1",
          //                         "ruleType": null,
          //                         "preRuleType": null
          //                     },
          //                     {
          //                         "ruleMessage": "新车上牌转人工",
          //                         "ruleId": "X00P002",
          //                         "argumen": "转人工核保",
          //                         "sourceInd": "1",
          //                         "ruleType": null,
          //                         "preRuleType": null
          //                     }
          //                 ]
          //             },
          //             {
          //                 "applyEndorNo": "2051107030120230000006",
          //                 "riskCode": "0301",
          //                 "underwriteInd": "9",
          //                 "reviewType": null,
          //                 "endorNo": null,
          //                 "ilogInfos": [
          //                     {
          //                         "ruleMessage": "需核实车牌",
          //                         "ruleId": "X00P001",
          //                         "argumen": "转人工核保",
          //                         "sourceInd": "1",
          //                         "ruleType": null,
          //                         "preRuleType": null
          //                     },
          //                     {
          //                         "ruleMessage": "新车上牌转人工",
          //                         "ruleId": "X00P002",
          //                         "argumen": "转人工核保",
          //                         "sourceInd": "1",
          //                         "ruleType": null,
          //                         "preRuleType": null
          //                     }
          //                 ]
          //             }
          //         ]
          //     }
          // }
          // this.$set(this,'endorByLicenseNoResult',result.result)
          // this.$set(this,'show',true);
          // this.dealDone(result);
        }
      });
    },
    sendSms(){
      if(!(this.endorByLicenseNoResult&&this.endorByLicenseNoResult.riskDtoList&&this.endorByLicenseNoResult.riskDtoList[0].applyEndorNo)) {
        !this.endorByLicenseNoResult&&this.endorByLicenseNoResult.riskDtoList&&this.endorByLicenseNoResult.riskDtoList[0].applyEndorNo && Toast('批单号获取失败，请联系IT人员~');
        return;
      }
      if(this.disabled) return;
      // applyEndorNo  申请批单号
      $get.endorIdentCode(
        {query:{ 
          endorNo: this.endorByLicenseNoResult&&this.endorByLicenseNoResult.riskDtoList&&this.endorByLicenseNoResult.riskDtoList[0].applyEndorNo  ||''
        }}).then((res)=>{
        if (res.resultCode == '0' || res.resultCode == '000000') {
          Toast("短信发送成功");
          this.countDown();
          this.$set(this,'disabled',true) // 按钮可以点击
        } else {
          Toast(res.errorMsg);
        }
      });
    },
    endorByLicenseNoApprover() {
      // 成功之后关闭弹框，关闭定时器
      if(!(this.endorByLicenseNoResult&&this.endorByLicenseNoResult.riskDtoList&&this.endorByLicenseNoResult.riskDtoList[0].applyEndorNo)) {
        !this.endorByLicenseNoResult&&this.endorByLicenseNoResult.riskDtoList&&this.endorByLicenseNoResult.riskDtoList[0].applyEndorNo && Toast('批单号获取失败，请联系IT人员~');
        return;
      }
      var data = {
        companyCode: this.endorByLicenseNoResult.companyCode,
        issueCode: this.verificationCode,
        operatorCode: this.endorByLicenseNoResult.operatorCode,
        vhlNo: this.licenseNo,
        endorNo: this.endorByLicenseNoResult&&this.endorByLicenseNoResult.riskDtoList&&this.endorByLicenseNoResult.riskDtoList[0].applyEndorNo || ''
      }
      // this.refreshing = true;
      $http.endorByLicenseNoApprover({data}).then((res)=>{
        if (res.resultCode == '0' || res.resultCode == '000000') {
          this.dealDone(res, true);
          this.countDown(true);
          // 关闭弹框
          this.$set(this,'show',false);
        } else {
          Toast(res.errorMsg);
        }
      });
    },
    countDown(flag){
      if(flag){
        // 完成流程 清除定时器
        clearInterval(this.stimeOut);
        this.$set(this,'disabled',false) // 按钮可以点击
        this.$set(this,'fresh_text','获取验证码');
        this.$set(this,'second',120);
      }
      let t = setInterval(()=>{
        let second = --this.second;
        this.$set(self,'second',second);
        this.$set(this,'fresh_text',second+'秒重新发送')
        if(this.second < 1){
          clearInterval(t);
          this.$set(this,'disabled',false) // 按钮可以点击
          this.$set(this,'fresh_text','重新获取');
          this.$set(this,'second',120);
        }
      },1000)
      this.stimeOut = t; 
    },
    dealDone(res, isEndor){
      var msg = "",
      riskDtoList = !!res.result && !this.isEmpty(res.result) && !!res.result.riskDtoList ? res.result.riskDtoList : [];
      !!isEndor && (riskDtoList = !!res.result && res.result.length>0 ? res.result : []);
      if (riskDtoList[0] && riskDtoList[0].ilogInfos) {
          riskDtoList.forEach((opt,index)=>{
            if(index !== 0) return;
            opt.ilogInfos.forEach((item,cur)=>{
              !!msg && (item.ruleMessage || item.argumen) && (msg += ',<br/>');// 第二次拼接添加逗号
                  msg += item.ruleMessage + '' + item.argumen;
            })
          })
      } else {
          msg += "录车牌受理成功,";
          // var tip1 = "",
          //     tip2 = "",
          //     tip3 = "";
          var obj = {
              jqRisk: {},
              syRisk: {},
              name: "批单号"
          };
          riskDtoList.forEach((item,cur)=>{
            if (item.riskCode == "0301") {
              obj.jqRisk.No = item.endorNo;
            }
            if (item.riskCode == "0312") {
              obj.syRisk.No = item.endorNo;
            }
          })
          msg += this.renderTipTpl(obj); //
      }
      Dialog.alert({
        title: '温馨提示',
        message: msg,
        theme:'round-button',
      })
      .then(() => {
        // on close
        let policyNo = '';
        let mergePolicyNo = '';
        let jqNo = '';
        let syNo = '';
        if(this.productCode==='0301'){
          policyNo = this.policyNo || '';
          jqNo = this.policyNo || '';
        }
        if(this.productCode==='0312'){
          policyNo = this.policyNo || '';
          syNo = this.policyNo || '';
        }
        if(this.mergeProductCode==='0301'){
          mergePolicyNo = this.mergePolicyNo;
          jqNo = this.mergePolicyNo || '';
        }
        if(this.mergeProductCode==='0312'){
          mergePolicyNo = this.mergePolicyNo || '';
          syNo = this.mergePolicyNo || '';
        }
        // location.href = process.env.VUE_APP_NOCAR_URL+`eb-web/wonhero/haclaim_app/index.html#/policyDetails1?policyNo=${policyNo}&mergePolicyNo=${mergePolicyNo}&jqNo=${jqNo}&syNo=${syNo}&from=newcar`;
        this.$router.push({path:'/policy_detail',query:{
          policyNo:this.policyNo||'',
          mergePolicyNo:this.mergePolicyNo || ''
        }});
      })
    },
    correctDate(t2) {
      let t1 = new Date().format('yyyy-MM-dd');
      let data = {};
      if (new Date(t1) < new Date(t2)) {
        data.date = new Date(t2);
        // text += t2.format('yyyy年MM月dd日') + '起生效';
        // cache.takeEffectTip = "批单生效日期为保单起期";
      } else {
        let t = new Date(t1);
        t.setDate(t.getDate() + 1);
        data.date = t;
        // text += t.format('yyyy年MM月dd日') + '起生效';
        // cache.takeEffectTip = "批单次日生效";
      }
      return data;
    },
    createTpl() {
      let html = [];
      html.push("{{NO_NAME}}");
      let t1Text = this.startDate,
          t2Text = this.mergeStartDate;
      //  var text = "";
      //您录入的新车车牌号为:闽F47774,自2017年10月20日起生效
      //如果原保单保险起期大于当前时间   传原保单保险起期，小于取当前日期下一天零点
      // 如果两个起期一样
      let d1Obj = this.correctDate(t1Text);
      if (t2Text && !!!t2Text && (t2Text != 'null' && t2Text != 'undefined' && typeof t2Text !== 'undefined')) {
        if (t2Text !== t1Text) {
          let d2Obj = this.correctDate(t2Text);
            // text += "保单号为:" + App.params.policyNo;
            // text += ",车牌修改生效日期为" + d1Obj.date.format('yyyy年MM月dd日');
            //text += "保单号为:" + App.params.mergePolicyNo;
            //text += "批单生效日期为" + d2Obj.date.format('yyyy年MM月dd日');

            html.push("为:" + "{{NO_" + this.productCode + "}}");
            html.push(",<br/>车牌修改生效日期为" + d1Obj.date.format('yyyy年MM月dd日') + "");
            html.push(",<br/>{{NO_NAME}}为:" + "{{NO_" + this.mergeProductCode + "}}");
            html.push(",<br/>车牌修改生效日期为" + d2Obj.date.format('yyyy年MM月dd日') + "");
        } else {

          //text += "保单号为:" + App.params.policyNo;
          // text += " " + App.params.mergePolicyNo;
          //  text += "车牌修改生效日期为" + d1Obj.date.format('yyyy年MM月dd日');

          html.push("为:" + "{{NO_" + this.productCode + "}}");
          html.push(",<br/>{{NO_" + this.productCode + "}}");
          html.push(",<br/>车牌修改生效日期为" + d1Obj.date.format('yyyy年MM月dd日') + "");
        }
      } else {
        //text += "保单号为:" + App.params.policyNo;
        //  text += "车牌修改生效日期为" + d1Obj.date.format('yyyy年MM月dd日');

        html.push("为:" + "{{NO_" + this.productCode + "}}");
        html.push(",<br/>车牌修改生效日期为" + d1Obj.date.format('yyyy年MM月dd日'));
      }
      return (html.join(''));
    },
    renderTipTpl(obj) {
      debugger
      var tpl = this.createTpl();
      //{{NO_NAME}}为:{{NO_0302}} {{NO_0302}},批单生效日期为{{DATA_0302}}
      tpl = tpl.replace(/{{NO_NAME}}/g, obj.name);
      tpl = tpl.replace(/{{NO_0301}}/g, obj.jqRisk.No);
      tpl = tpl.replace(/{{NO_0312}}/g, obj.syRisk.No);
      return tpl;
    },
    getPolicyObj() {
      var syRisk = {},
      jqRisk = {};
      // .replaceAll("{{NO_0302}}", "保单号")
      if(this.productCode == "0301") {
        jqRisk.No = this.policyNo;
          // jqRisk.startDate = App.params.startDate;
      }else if(this.productCode == "0312"){
        syRisk.No = this.policyNo;
      }
      if(this.mergeProductCode == "0301") {
        jqRisk.No = this.mergePolicyNo;
          // jqRisk.startDate = App.params.startDate;
      }else if(this.mergeProductCode == "0312")  {
        syRisk.No = this.mergePolicyNo;
      }
      var data = {};
      data.syRisk = syRisk;
      data.jqRisk = jqRisk;
      data.name = "保单号";
      return data
    },
    next(){
      Dialog.confirm({
        title: '录入车牌确认',
        message: `您录入的新车车牌号为:${this.licenseNo},<br/>${this.renderTipTpl(this.getPolicyObj())}`,
        theme:'round-button',
      })
      .then(() => {
        // on confirm
        this.endorByLicenseNo();
      })
      .catch(() => {
        // on cancel
      });
    },
    isEmpty(object){
      if ((object === null
          || typeof (object) === "undefined")
          || (typeof (object) === "string" && object === "" && object !== undefined)
          || (typeof (object) === 'object' && object.length === 0)) {
          return true;
      } else if (typeof (object) === "string" && object.length > 0) {
        return false;
      }
      else if (Object.keys(object).length === 0) {
        return true;
      }
      else {
        return false;
      }
    }
  }   
}
